import { IconButton } from "@mui/material";
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF, GridColDef } from "@mui/x-data-grid-premium";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

import { useTrackingActions, useTrackingExpandedRows } from "@/stores/use-tracking-table";
import { IPlanPassenger, Task } from "@/types/tasks.types";

export function TrackingDetailPanelColumn({ rows }: { rows: Task<IPlanPassenger<"api">>[] }): GridColDef<Task> {
    return {
        ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
        renderHeader: () => {
            const expandedRows = useTrackingExpandedRows();
            const { handleExpandAll } = useTrackingActions();

            return (
                <div className="w-full grid place-items-center">
                    <IconButton onClick={() => handleExpandAll(rows)}>
                        {expandedRows.length && expandedRows.length === rows.length ? (
                            <TbChevronUp size={18} />
                        ) : (
                            <TbChevronDown size={18} />
                        )}
                    </IconButton>
                </div>
            );
        },
    };
}
